import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

//Works like tables in SQL
export class Containers {

  //Loads all containers inside of a bucket.
  static async load(bucket_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          bucket: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  //Get just one single container item by his id.
  static async get(container_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          container: container_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  //Add a new container inside of a bucket.
  static async add(bucket_id, container_name) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          bucket: bucket_id,
          name: container_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  //Edit an exisiting container by providing a new name and exisiting container id.
  static async edit(container_id, container_name) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: container_id,
          name: container_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  //Delete a exisiting container by his id.
  static async delete(container_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: container_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
